import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
	OrganisationActiveStatusRequest,
	IOrganisationActiveStatusRequest,
	OrganisationActiveStatusResponse,
} from '@joc/api-gateway';

import { ORGANIZATIONS_QUERY_KEY } from 'core/constants';

import { API } from 'core/API';

interface IUseUpdateActiveStatusOrganization {
	// eslint-disable-next-line no-unused-vars
	updateActiveStatusOrganization: (values: IOrganisationActiveStatusRequest) => void;
}

const updateActiveStatusOrganizationApi = async (values: IOrganisationActiveStatusRequest) => {
	const requestBody = OrganisationActiveStatusRequest.fromJS(values);

	return API.updateOrganisationActiveStatus(OrganisationActiveStatusRequest.fromJS(requestBody));
};

export const useUpdateActiveStatusOrganization = (): IUseUpdateActiveStatusOrganization => {
	const queryClient = useQueryClient();
	const { mutate: updateActiveStatusOrganization } = useMutation<
		OrganisationActiveStatusResponse,
		Error,
		IOrganisationActiveStatusRequest
	>({
		mutationFn: values => updateActiveStatusOrganizationApi(values),
		onSettled: () => queryClient.invalidateQueries({ queryKey: [ORGANIZATIONS_QUERY_KEY] }),
	});

	return { updateActiveStatusOrganization };
};
